import { render } from "./Newspaper.vue?vue&type=template&id=024ac0fb"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Newspaper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "024ac0fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('024ac0fb', __exports__)) {
    api.reload('024ac0fb', __exports__)
  }
  
  module.hot.accept("./Newspaper.vue?vue&type=template&id=024ac0fb", () => {
    api.rerender('024ac0fb', render)
  })

}


export default __exports__